"use client";

import { capitalizeFirstLetter, formatTitle, splitPath } from "@/lib";
import { usePathname } from "next/navigation";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@focal/ui-kit";
import { useCallback } from "react";
import { routes } from "@/constants";
import { Icon } from "@focal/ui-kit";
import Link from "next/link";
import { usePageStore } from "@/store/page";

export const Breadcrumbs = ({
  currentPageTitle,
  action,
}: {
  currentPageTitle?: string;
  action?: () => void;
}) => {
  const pathname = usePathname();
  const pathArray = splitPath(pathname);
  const { title: pageTitle } = usePageStore();
  const getTitle = (title: string) => {
    switch (title) {
      case "home":
        return "Today";
      case "in-person":
        return "Transcribe in-person meeting";
      case "video-meeting":
        return "Add Focal via link to video meeting";
      default:
        return "";
    }
  };

  const getTitleIcon = useCallback(() => {
    if (pathname.includes(routes.home.index)) {
      return <Icon name="CalendarIcon" size="md" />;
    }
    if (pathname.includes(routes.inPerson.index)) {
      return <Icon name="MicIcon" size="md" />;
    }
    if (pathname.includes(routes.videoMeeting.index)) {
      return <Icon name="MergeIcon" size="md" />;
    }
    if (pathname.includes(routes.conversations.index)) {
      // return <Icon name="NotebookTabsIcon" size="md" />;
      return null;
    }
    if (pathname.includes(routes.clients.index)) {
      return <Icon name="GroupIcon" size="md" />;
    }
    if (pathname.includes(routes.settings.index)) {
      return <Icon name="SettingsIcon" size="md" />;
    }
  }, [pathname]);

  return (
    <Breadcrumb className="py-2.5">
      <BreadcrumbList>
        {pathArray.map((segment, index) => {
          const href = "/" + pathArray.slice(0, index + 1).join("/");
          const title =
            getTitle(segment) || formatTitle(capitalizeFirstLetter(segment));
          const isLastItem = index === pathArray.length - 1;
          const isFirstItem = !index;

          return (
            <div
              key={segment}
              className="flex flex-row justify-center items-center ml-2"
            >
              <BreadcrumbItem>
                {isFirstItem && getTitleIcon()}
                {isLastItem ? (
                  <BreadcrumbPage
                    onClick={() => {
                      if (action) {
                        action();
                      }
                    }}
                    className={action ? "cursor-pointer" : ""}
                  >
                    {currentPageTitle || pageTitle || title}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link href={href}>{title}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLastItem && <BreadcrumbSeparator className="ml-4" />}
            </div>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
